var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButtonMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5527344,21.6582031L11.7890625,4.2763672C11.4277344,4.0957031,11.0224609,4,10.6181641,4 C9.1748047,4,8,5.1748047,8,6.6181641v34.7636719C8,42.8251953,9.1748047,44,10.6181641,44 c0.4042969,0,0.8095703-0.0957031,1.1708984-0.2763672l34.7646484-17.3818359C47.4453125,25.8945312,48,24.9970703,48,24 S47.4453125,22.1054688,46.5527344,21.6582031z M45.6582031,24.5527344L10.8945312,41.9345703 C10.5078125,42.1308594,10,41.8193359,10,41.3818359V6.6181641C10,6.2773438,10.2773438,6,10.6181641,6 c0.0957031,0,0.1914062,0.0224609,0.2763672,0.0654297l34.7626953,17.3818359C45.8691406,23.5527344,46,23.7646484,46,24 S45.8691406,24.4472656,45.6582031,24.5527344z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonMedium);
export default __webpack_public_path__ + "static/media/play-button--medium.e76b544df4a9efa77013337fe26dd63a.svg";
export { ForwardRef as ReactComponent };